import { CompactUserResponse, UserResponse, UserRole } from '@business/entities/account';
import { ProgramStatus } from '@business/entities/programs';

export function getStatusName(status: ProgramStatus) {
  switch (status) {
    case ProgramStatus.all:
      return 'All';
    case ProgramStatus.active:
      return 'Active';
    case ProgramStatus.archived:
      return 'Archived';
    case ProgramStatus.completed:
      return 'Completed';
  }
}
